import { useAppSelector } from 'app/hooks';
import ConfidenceScoreChip from 'components/common/confidence-score-chip';
import ProjectSetting from 'components/common/project-setting';
import { CUSTOMER_PREFERENCE_QUESTIONS } from './customer-preference-questions';

// The Customer Preferences questionnaire plus the live confidence score it
// feeds (AHA-6796). Hosted by the side panel on every pathway; on the
// compatibility pathway it is the panel's only content.
export default function CustomerPreferencesQuestionsSection() {
  const projectSettings = useAppSelector(
    (state) => state.project.projectSettings
  );

  return (
    <div className='flex flex-col gap-4'>
      <div className='text-xl font-bold text-gray-900'>
        Customer Preferences
      </div>
      <div className='flex flex-col gap-4'>
        {CUSTOMER_PREFERENCE_QUESTIONS.map((entry) => {
          if (entry.kind === 'checkbox-group') {
            return (
              <div key={entry.question} className='flex flex-col gap-2'>
                <span className='text-sm font-medium text-gray-700'>
                  {entry.question}
                </span>
                {entry.codes.map((code) => (
                  <ProjectSetting key={code} code={code} showLabel />
                ))}
              </div>
            );
          }
          if (
            entry.visibleWhen &&
            projectSettings.find((ps) => ps.code === entry.visibleWhen?.code)
              ?.value !== entry.visibleWhen.value
          ) {
            return null;
          }
          return (
            <div key={entry.code} className='flex flex-col gap-1'>
              <span className='text-sm font-medium text-gray-700'>
                {entry.question}
              </span>
              <ProjectSetting code={entry.code} debounce={entry.debounce} />
            </div>
          );
        })}
      </div>
      {/* Live confidence score (AHA-6796): the want-side answers above feed
          it, refreshed after each autosave completes. */}
      <ConfidenceScoreChip />
    </div>
  );
}
